/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
export class InvalidMetricError extends Error {
    constructor(name, violation, critical, val, limitOrDefault) {
        super(`Bad metric encountered: ${name} - ${violation}`);
        this.name = name;
        this.violation = violation;
        this.critical = critical;
        this.val = val;
        this.limitOrDefault = limitOrDefault;
    }
}
export class InvalidNavigationTimingError extends Error {
    constructor(name, violation, critical, val, limitOrDefault) {
        super(`Bad timing metric encountered: ${name} - ${violation}`);
        this.name = name;
        this.violation = violation;
        this.critical = critical;
        this.val = val;
        this.limitOrDefault = limitOrDefault;
    }
}
